// extracted by mini-css-extract-plugin
export var actionText = "_p2-4";
export var container = "_p2-0";
export var leftSection = "_p2-1";
export var rightSection = "_p2-2";
export var settingsButton = "_p2-6";
export var settingsIcon = "_p2-7";
export var shortcut = "_p2-5";
export var shortcutGroup = "_p2-3";